export default __webpack_public_path__ + "static/media/x-circle.60561430.svg";